export default "/assets/images/flag-ukraine.cf65170c72e5849a.jpg";